import { render, staticRenderFns } from "./Area10.vue?vue&type=template&id=4675b0cc&scoped=true&"
import script from "./Area10.vue?vue&type=script&lang=js&"
export * from "./Area10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675b0cc",
  null
  
)

export default component.exports